// src/modules/communications.js
//
// Communications module manifest.
// Controls: CallPanel, WalkiePanel, CommunicationsPage route.

export default {
  id: 'communications',
  label: 'Communications',

  // Stores to initialize when module is active
  stores: {
    callStore: {
      import: () => import('@/stores/callStore'),
      storeId: 'callStore',
      // Any signed-in user needs presence + the sessions subscription so
      // they can be invited into an active call. The CallPanel itself still
      // stays hidden when there are no calls for them; this just lets the
      // Invite-to-Call banner fire for non-admin invitees. Voice-agent
      // gating (answering inbound calls, etc.) still lives inside the panel.
      init: (store, { roles: _roles }) => {
        store.initPresence()
        store.subscribeToCallSessions()
      },
      cleanup: store => {
        store.stop?.()
      },
    },
  },

  // Global components mounted at App level (alongside router-view)
  globalComponents: {
    CallPanel: () => import('@/components/Communications/CallPanel.vue'),
    WalkiePanel: () => import('@/components/Communications/WalkiePanel.vue'),
  },

  // Route names owned by this module (for conditional registration)
  routes: ['Communications'],

  // Navigation items for HeaderComponent
  nav: [{ label: 'Communications', routeName: 'Communications', group: 'tools' }],
}
